import { Purchases } from "@revenuecat/purchases-js";
import { useEffect, useState } from "react";
import { proEntitlementID } from "../../constants";
import { useMyMember } from "../../redux/member/memberHooks";

export function usePro() {
  const { member } = useMyMember();
  const [pro, setPro] = useState<boolean>();

  useEffect(() => {
    try {
      Purchases.getSharedInstance()
        .getCustomerInfo()
        .then((c) => {
          setPro(proEntitlementID in c.entitlements.active);
        });
    } catch (e) {
      // Handle errors fetching customer info
    }
  }, [member]);

  return member?.pro ? true : pro;
}
